import { EmailElement } from './email-element-folder';

export {
  EmailElement,
};



// WEBPACK FOOTER //
// src/common/form-elements/index.js